import { Components } from "../../utils/components";
import { BaseSubmittableForm } from "./base-submittable-form";
export class UmbracoEnquiryForm extends BaseSubmittableForm {
  constructor(element) {
    super(element); // Jquery may not work here.
  }

  init() {// Jquery may not work here
  }

  bindFields() {}

  submit() {
    if (this.isSubmitting()) {
      return;
    }

    this.beginSubmitting();
    this.delay(900).then(() => {
      const areas = ["#umbraco-enquiry-form"];
      this.doSubmit(null, null).then(result => {
        if (result != null) {
          this.endSubmitting();
          window.recaptchaInit();
        }
      });
    });
  }

}
Components.data(UmbracoEnquiryForm, "umbracoEnquiryForm");